// extracted by mini-css-extract-plugin
export default {"container":"yZ-z","topReviewHeading":"zZ-z","criticalReview":"AZ-z","favorableReview":"BZ-z","vsSeparator":"CZ-z"};